import { render, staticRenderFns } from "./ZoneRecycleBinModal.vue?vue&type=template&id=08bad570&scoped=true"
import script from "./ZoneRecycleBinModal.vue?vue&type=script&lang=js"
export * from "./ZoneRecycleBinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bad570",
  null
  
)

export default component.exports